import BaseTextField from "../../../../components/ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const HalfDayPay = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);

  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );

    if (name === "halfDayRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "halfDayRate",
          data: false,
        })
      );
    }
    if (name === "halfDayRate" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "halfDayRate",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "halfDayRateErrorMsg",
          data: "Half Day Rate is required",
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.halfDayRate}
          errorMsg={workOrderFormValidation.halfDayRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="halfDayRate"
          name="halfDayRate"
          label="Half Day Rate"
          requirement="required"
          labelShrink={false}
          value={payment.halfDayRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      <div>
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.hourlyRate}
          errorMsg={workOrderFormValidation.hourlyRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="hourlyRate"
          name="hourlyRate"
          label="Additional Hour Rate"
          requirement="required"
          labelShrink={false}
          value={payment.hourlyRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
        <p className="mt-2 text-sm text-right">
          Additional hourly rate will be applicable after 4 hours of Work
        </p>
      </div>
    </div>
  );
};

export default HalfDayPay;
